export default __webpack_public_path__ + "static/sprite-fc76b8ec8744ee84456f8cd9d3712707.svg";